import {Box, Button, Divider, Stack} from '@mui/material';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {AlertInfo, EmptySearchState} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useRequestSchedulePermissionCard} from './hooks/useRequestSchedulePermissionCard';
import {RequestSchedulePermission} from '../RequestSchedulePermission';
import {RequestSchedulePermissionCardProps} from './types';

const {call, callToChat, noResults} = translations['pt-br'].commons;
const {unitsFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {choosePhoneNumber} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export const RequestSchedulePermissionCard = ({
	healthRequestSchedulePermission,
}: RequestSchedulePermissionCardProps) => {
	const {
		handleClosePhoneMenu,
		handleTogglePhoneDrawer,
		handleOpenPhoneMenu,
		handleCallChatRoom,
		isPhoneNumberMenuOpen,
		openPhoneDrawerState,
		phoneNumbers,
		phoneNumbersAlert,
		anchorEl,
		callChatRoomIsLoading,
		isMobile,
	} = useRequestSchedulePermissionCard();

	return (
		<Fragment>
			<EmptySearchState
				title={noResults}
				description={unitsFlow.notFoundModal.requestSchedulePermission}>
				<Stack gap={2}>
					<RequestSchedulePermission
						requestAlreadyExists={healthRequestSchedulePermission.requestAlreadyExists}
						requestCity={healthRequestSchedulePermission.requestCity}
					/>

					<Divider />

					<Button
						onClick={handleCallChatRoom}
						size="large"
						variant="outlined"
						disabled={callChatRoomIsLoading}
						endIcon={
							callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
						}
						data-tag-id={
							AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO
						}>
						{callToChat}
					</Button>
					<Button
						onClick={handleOpenPhoneMenu}
						size="large"
						variant="outlined"
						data-tag-id={AppointmentBookingEnum.CLICK_LIGAR_AGENDAMENTO}>
						{call}
					</Button>
				</Stack>
			</EmptySearchState>

			{isMobile ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>

					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesDrawer.Root>
			) : (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<Box pb={2}>
						<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					</Box>

					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesMenu.Root>
			)}
		</Fragment>
	);
};
